export const SUCCESS_SNACKBAR = 'successSnackbar';
export const ERROR_SNACKBAR = 'errorSnackbar';
export const INFO_SNACKBAR = 'infoSnackbar';
export const WARNING_SNACKBAR = 'warningSnackbar';

export type SnackbarInfoType = {
    message: string
    action: string
    type: SnackbarType,
    persistent?: boolean
}

export type SnackbarType = typeof SUCCESS_SNACKBAR | typeof ERROR_SNACKBAR | typeof INFO_SNACKBAR | typeof WARNING_SNACKBAR;
